import { render } from "./EditPickup.vue?vue&type=template&id=0c3b1cdc&ts=true"
import script from "./EditPickup.vue?vue&type=script&lang=ts"
export * from "./EditPickup.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__